module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPAAAAAYCAYAAADEQnB9AAAABHNCSVQICAgIfAhkiAAAAUZJREFUeJzt3DFOAlEUheFzHwMNDRU1SyCuwIQNSEuHiaHWjVgTjXS0xAW4BlkCtYXSWCHvWCCJjUo3PPy/apKZ4hbzv6nmhiRNZoueojnLcj8pOgJwtEJa2Jub6Xi4isls0ctRPRMuUI6Q3uzNWeVo3Sa5I/nJ0bhL8nvdwwH4SXTt7ciKgaP5kEK+kKSIxpx4gWPnl3B1L0kh9dP3G3WNBOBwbuw+tJY66a+HARwvAgYKRsBAwQgYKBgBAwUjYKBgBAwUjICBghEwUDACBgpGwEDBCBgoGAEDBSNgoGAEDBQsZXktSVm5XfcwAA6Q3d1fVg3F0tJ5WFcKz6Xgx378yhFR9wz/Vd7mdiiPIpJkP1b2Zvy11G5gayC57hlx7Mw7UpcUkpSUrdekj+uQdmtlHa3b/X4snBZzKp+StaRleHM5HQ9Xn9cuYBtGvqFsAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/racks/drawer-3-selected.png
// module id = 6d/f
// module chunks = 0